export const HOLIDAYS = {
  "2026-01-01": "New Year",
  "2026-01-26": "Republic Day",
  "2026-08-15": "Independence Day",
  "2026-10-02": "Gandhi Jayanti",
  "2026-12-25": "Christmas"
};